import actions from './actions'
import mutations from './mutations'

const card = {
    namespaced: true,
    state: {
        cards: [],
        filters: {
            clientId: null,
            paymentId: null,
            phoneNumber: null
        },
        pagination: {
            length: null,
            page: 1,
            total: null
        },
        isLoaded: false
    },
    mutations,
    actions
}

export default card
